module.exports = __webpack_public_path__ + "d72bda1ce0e0e6b1a83b44f21d3e2e6a.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-ampush.png
// module id = 628
// module chunks = 0